import Vue from 'vue';
import Vuex from 'vuex';

import { user } from './modules/user';
import { search } from './modules/search';
import { dashboard } from './modules/dashboard';
import { savedSearch } from './modules/savedSearch';
import { cancellation } from './modules/cancellation';

Vue.use(Vuex);

export default new Vuex.Store({
    /*     
        In strict mode, whenever Vuex state is mutated outside of mutation handlers, an error will be thrown.
        This ensures that all state mutations can be explicitly tracked by debugging tools. 
    */
    // strict: process.env.NODE_ENV !== 'production',
    modules: {
        user,
        search,
        dashboard,
        savedSearch,
        cancellation,
    },
});
